import { Grid, MenuItem, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import { notificationSettingsKeys } from "../../../../../../api/queryKeys";
import { operationStatus } from "../../../../../../components/ActionStatus";
import { field_IDs_mapping } from "../../../fieldMapping";
import DropDownButton from "./DropDownButton";

const START_TIME = "08:00:00";
const END_TIME = "20:00:00";

function generateHourlyTimes(start, end) {
  const times = [];
  let [startHour] = start.split(":").map(Number);
  const [endHour] = end.split(":").map(Number);

  while (startHour <= endHour) {
    const formattedTime = `${String(startHour).padStart(2, "0")}:00:00`;
    times.push(formattedTime);
    startHour++;
  }

  return times;
}

function convertToAmPm(time24) {
  if (!time24) return "";
  let [hours, minutes] = time24.split(":").map(Number);
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
  const formattedTime = `${String(hours).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")} ${ampm}`;
  return formattedTime;
}

export default function DaySelector({
  method,
  setFetchStatus,
  defaultSelectedTime,
  disabled,
}) {
  const { updateNotificationSetting } = useAPI();
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const availableTimes = generateHourlyTimes(START_TIME, END_TIME);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const queryClient = useQueryClient();

  const onTimeClick = (newTime) => {
    setMenuIsOpen(false);
    if (newTime === defaultSelectedTime) return;

    setButtonDisabled(true);
    setFetchStatus(operationStatus.LOADING);

    updateNotificationSetting(method, field_IDs_mapping.FREQUENCY.TIME, newTime)
      .then(() => {
        setFetchStatus(operationStatus.SUCCESS);
        queryClient.invalidateQueries({
          queryKey: notificationSettingsKeys.all,
        });
      })
      .catch(() => {
        setFetchStatus(operationStatus.ERROR);
      })
      .finally(() => {
        setButtonDisabled(false);
      });
  };

  return (
    <DropDownButton
      text={convertToAmPm(defaultSelectedTime)}
      onClose={() => setMenuIsOpen(false)}
      onClick={() => setMenuIsOpen(true)}
      open={menuIsOpen}
      disabled={buttonDisabled || disabled}
      menuStyle={{ maxHeight: "420px" }}
      sx={{ width: "130px" }}
    >
      <Grid container direction="column" width="128px">
        {availableTimes.map((time) => (
          <Grid item>
            <MenuItem
              selected={time === defaultSelectedTime}
              onClick={() => onTimeClick(time)}
            >
              <Typography variant="caption">{convertToAmPm(time)}</Typography>
            </MenuItem>
          </Grid>
        ))}
      </Grid>
    </DropDownButton>
  );
}
